module.exports = __webpack_public_path__ + "media/76.105311de.mp3";